import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Component, Output, TemplateRef, ViewChild, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.scss'],
})
export class SuccessModalComponent {
  @ViewChild('successModal') successModal: TemplateRef<any>;
  @Output() closeModalEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  modalRef: BsModalRef;
  isSuccess = false;
  text: string;
  alertIcon = false;
  @Input() showCloseButton = true;
  @Input() title = "";
  @Input() textDanger = false;
  constructor(private modalService: BsModalService) {}

  public openSuccessModal(isSuccess: boolean, text?: string, alert?: boolean): void {
    this.isSuccess = isSuccess;
    this.text = text || (isSuccess ? 'ทำรายการสำเร็จ' : 'ทำรายการไม่สำเร็จ');
    this.alertIcon = alert;
    this.modalRef = this.modalService.show(this.successModal, {
      class: 'modal-md modal-dialog-centered',
      backdrop: 'static',
      keyboard: false,
    });

    setTimeout(() => {
      this.closeModal();
    }, 1500);
  }

  closeModal(): void {
    this.modalRef.hide();
    this.closeModalEvent.emit(true);
  }
}
